import React from 'react';
import { useListings } from '@/utils/context/ListingsContext';

const ListingType: React.FC = () => {
    const { listings, handleSearchSubmit } = useListings();
    const typeOptions: Record<string, string> = {
        Sale: 'S', 
        Rent: 'R', 
    };
    const currentValue: string = listings.params.salerent ? listings.params.salerent.value : 'S';

    const handleChange = ( e: React.ChangeEvent<HTMLInputElement> ) => {
        const form = e.currentTarget.form;
        if ( form ) {
            handleSearchSubmit( { preventDefault: () => {}, currentTarget: form } as unknown as React.FormEvent<HTMLFormElement> );
        }
    };

    return (
        <span className="mls-field-wrapper mls-field-listing-type">
            <span className="mls-field-inner-wrapper full">
            { Object.entries( typeOptions ).map( ( [ label, value ] ) => {
                const checked: Record<string, any> = currentValue === value ? { checked: '1' } : {};
                return (
                    <>
                    <input type="radio" name="SaleRent" value={ value } id={ `SaleRent-${value}` } onChange={ handleChange } { ...checked } />
                    <label htmlFor={ `SaleRent-${value}` }><span>For { label }</span></label>
                    </>
                );
            } ) }
            </span>
        </span>
    );
}
export default ListingType;